var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 784,
    height: 49,
    viewBox: "0 0 784 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719 0H-213V49H719V0Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 0H731V49H742V0Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 0H752V49H763V0Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 0H773V49H784V0Z",
    fill: "#1B7691"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue);
export default __webpack_public_path__ + "static/media/lightblue.21b7d8145489ce9b2a26600cea65bf2e.svg";
export { ForwardRef as ReactComponent };